(function () {
'use strict';

angular
    .module('riskSelfAssessmentReviewRoutes', [
        'riskModule',
        'riskSelfAssessmentReviewControllers'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
            .state('riskSelfAssessmentReviewTopRisks', {
                url: '/RiskSelfAssessment/Review/Risk/Top',
                resolve: {
                    govProcess: ['grcGovernanceProcessService', function (service) {
                        return service.getActiveRiskSelfAssessments();
                    }],
                    criterias: ['commonRiskSelfAssessmentService', function (service) {
                        return service.getAllCriterias();
                    }],
                    topRisksToReview: ['riskSelfAssessmentReviewService', function (service) {
                        return service.getTopRisksToReview();
                    }]
                },
                templateUrl: require('./reviewTopRiskList.tpl.html'),
                controller: 'RiskSelfAssessmentReviewTopRiskListController'
            })

             .state('riskSelfAssessmentReviewRisk', {
                 url: '/RiskSelfAssessment/Review/Risk/{RiskID:int}',
                 resolve: {
                     govProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveRiskSelfAssessments();
                     }],
                     criterias: ['commonRiskSelfAssessmentService', function (service) {
                         return service.getAllCriterias();
                     }],
                     riskToReview: ['$stateParams', 'riskSelfAssessmentReviewService', function ($stateParams, service) {
                         return service.getRiskToReview($stateParams.RiskID);
                     }]
                 },
                 templateUrl: require('./reviewRisk.tpl.html'),
                 controller: 'RiskSelfAssessmentReviewRiskController'
             })

            .state('riskSelfAssessmentReviewByAssessor', {
                url: '/RiskSelfAssessment/Review/Assessor@{AssessorID:int}',
                resolve: {
                    assessorId: ['$stateParams', function ($stateParams) {
                        return $stateParams.AssessorID;
                    }],
                    govProcess: ['grcGovernanceProcessService', function (service) {
                        return service.getActiveRiskSelfAssessments();
                    }],
                    criterias: ['commonRiskSelfAssessmentService', function (service) {
                        return service.getAllCriterias();
                    }],
                    risksToReview: ['assessorId', 'riskSelfAssessmentReviewService', function (assessorId, service) {
                        return service.getRisksToReview(assessorId);
                    }],
                    assessmentQuestions: ['assessorId', 'commonRiskSelfAssessmentService', function (assessorId, service) {
                        return service.getAssessmentQuestions(assessorId);
                    }]
                },
                templateUrl: require('./reviewByAssessor.tpl.html'),
                controller: 'RiskSelfAssessmentReviewByAssessorController'
            })

            .state('riskSelfAssessmentReviewByAssessor.preliminaryQuestions', {
                url: '/PreliminaryQuestions',
                views: {
                    'mainContent@riskSelfAssessmentReviewByAssessor': {
                        templateUrl: require('./reviewPreliminaryQuestions.tpl.html'),
                        controller: 'RiskSelfAssessmentReviewPreliminaryQuestionsController'
                    }
                }
            })

            .state('riskSelfAssessmentReviewByAssessor.risk', {
                url: '/Risk/{RiskID:int}',
                views: {
                    'mainContent@riskSelfAssessmentReviewByAssessor': {
                        templateUrl: require('./reviewByAssessorRisk.tpl.html'),
                        controller: 'RiskSelfAssessmentReviewByAssessorRiskController',
                    }
                }
            })

            .state('riskSelfAssessmentReviewByAssessor.finalQuestions', {
                url: '/FinalQuestions',
                views: {
                    'mainContent@riskSelfAssessmentReviewByAssessor': {
                        templateUrl: require('./reviewFinalQuestions.tpl.html'),
                        controller: 'RiskSelfAssessmentReviewFinalQuestionsController'
                    }
                }
            })

            .state('riskSelfAssessmentReviewByAssessor.summary', {
                url: '/Summary',
                views: {
                    'mainContent@riskSelfAssessmentReviewByAssessor': {
                        templateUrl: require('./reviewByAssessorSummary.tpl.html'),
                        controller: 'RiskSelfAssessmentReviewByAssessorSummaryController',
                    }
                }
            });

        // History Context
        historyCtxtServiceProvider.setCtxtState('riskSelfAssessmentReviewByAssessor.summary',
            '/app/Main/riskSelfAssessment/review/GOVHistoryCtxtDirective-riskSelfAssessmentReviewSummary.tpl.html'
        );
    }
})();
